function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useContext, useEffect, useReducer } from 'react';
import { Form, Row, Col } from 'antd';
import classnames from 'classnames';
import Button from "../../button";
import Element from "../element";
import { calcNamePath } from "../../utils/form-utils";
import FormContext from "../../form-context";
import { LocaleContext } from "../../locale";
import "./style";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Page = function Page(_ref) {
  var parentName = _ref.parentName,
    _ref$config = _ref.config,
    _ref$config$elements = _ref$config.elements,
    elements = _ref$config$elements === void 0 ? [] : _ref$config$elements,
    name = _ref$config.name,
    getButtonDisabledState = _ref$config.getButtonDisabledState,
    shouldRender = _ref$config.shouldRender,
    className = _ref$config.className,
    _ref$showFooter = _ref.showFooter,
    showFooter = _ref$showFooter === void 0 ? true : _ref$showFooter;
  var _useContext = useContext(FormContext),
    onCancel = _useContext.onCancel,
    cancelText = _useContext.cancelText,
    submitText = _useContext.submitText,
    submitting = _useContext.submitting,
    showSubmitButton = _useContext.showSubmitButton,
    form = _useContext.form,
    registerDependencies = _useContext.registerDependencies;
  var _useReducer = useReducer(function (r) {
      return r + 1;
    }, 0),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    _ = _useReducer2[0],
    dispatch = _useReducer2[1];
  var _useContext2 = useContext(LocaleContext),
    formatMessage = _useContext2.formatMessage;
  var buttonDisabled = getButtonDisabledState && form && getButtonDisabledState(form);
  useEffect(function () {
    var subscribe = Boolean(shouldRender) || Boolean(getButtonDisabledState);
    if (subscribe) {
      registerDependencies('SUBSCRIBE_ALL', dispatch);
    }
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: classnames('igloo-page-container', className),
    children: [/*#__PURE__*/_jsx("div", {
      className: 'igloo-page-content',
      children: /*#__PURE__*/_jsx(Row, {
        gutter: [32, 24],
        children: elements.map(function (child, index) {
          return /*#__PURE__*/_jsx(Element, {
            config: child,
            parentName: calcNamePath(parentName, name)
          }, index);
        })
      })
    }), showFooter && showSubmitButton && /*#__PURE__*/_jsxs("div", {
      className: 'igloo-page-footer',
      children: [onCancel && /*#__PURE__*/_jsx(Col, {
        children: /*#__PURE__*/_jsx(Button, {
          className: 'igloo-page-cancel-button',
          onClick: onCancel,
          children: cancelText || formatMessage({
            id: 'Cancel'
          })
        })
      }), !onCancel && /*#__PURE__*/_jsx("div", {}), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          type: "primary",
          htmlType: "submit",
          className: 'igloo-page-submit-button',
          loading: submitting,
          disabled: buttonDisabled,
          children: submitText || formatMessage({
            id: 'Submit'
          })
        })
      })]
    })]
  });
};
export default Page;